import { render, staticRenderFns } from "./DepartureTabsSummary.vue?vue&type=template&id=10769462&scoped=true&"
import script from "./DepartureTabsSummary.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsSummary.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsSummary.vue?vue&type=style&index=0&id=10769462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10769462",
  null
  
)

export default component.exports